import { CILabel } from 'ccs-ui-components';
import { Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { IQueryPathParam } from '../../../../../../models';
import InputHandler from '../../param-handler/InputHandler';
import ItemHandler from '../../param-list-handler/ItemHandler';
import classes from './HeaderParamFields.module.scss';

interface IHeaderParamProps {
  isEdit: boolean;
  headerParamListHandler: (data: IQueryPathParam[]) => void;
  headerParamList: IQueryPathParam[];
}
const HeaderParamFields = ({
  isEdit,
  headerParamListHandler,
  headerParamList
}: IHeaderParamProps) => {
  const { t: translate } = useTranslation();
  return (
    <Row>
      <Form.Group className="pb-3">
        <CILabel isMandatory id="headerParamKey" labelText={translate('service_operation_form.service_header_param')} />
        {isEdit ? (
          <InputHandler
            listOfItems={headerParamListHandler}
            paramName="Header Param"
            list={headerParamList}
          />
        ) : (
          <Row className={classes['param-container']}>
            <Row className={classes['param-header']}>
              <Col sm={5}>{translate('service_operation_form.param_key')}</Col>
              <Col sm={6} className={classes['value-header']}>
                {translate('service_operation_form.param_value')}
              </Col>
            </Row>
            {(!headerParamList
              || headerParamList?.length < 1) && (
                <div className={classes['no-data']}>
                  {translate('service_details_form_component.plchd_no_records', {
                    replace: { param: 'Header Param' }
                  })}
                </div>
              )}
            {headerParamList?.map((item, index) => (
              <ItemHandler
                key={item.key}
                index={index}
                itemKey={item.key}
                itemValue={item.value}
                isEdit={item.isEdit}
                isView
              />
            ))}
          </Row>
        )}
      </Form.Group>
    </Row>
  );
};

export default HeaderParamFields;
